import { useEffect, useState } from 'react'
import { useURLParams } from './useURLParams'
import { info, logException } from '../services/sentryLogger'
import { CommonValueType } from '../context/types'
import { QueryParams } from '../services/types'
import { FSM_STATES } from '../context/defaultState'
import { postLogin } from '../services/helpers'
import { apiService } from '../services/apiServices'
import { isAxiosError } from 'axios'

export const useAutoLogin = (commons: CommonValueType) => {
    const [params, loading] = useURLParams(
        'token',
        'a',
        'b',
        'email',
        'slug',
        'source',
        'from',
        'language'
    )
    const queryParams = params as QueryParams;
    const { token, a, b, email } = queryParams;

    const [isAuto, setIsAuto] = useState(loading)

    useEffect(() => {
        if (!isAuto) {
            commons.setState((s) => ({
                ...s,
                fsmState: FSM_STATES.AUTH,
            }))
        }
    }, [isAuto])

    useEffect(() => {
        (async () => {
            info('auto loginWithJWT or AB', { email, token, a, b, loading })
            if(loading) return;
            if (!email || (!token && !(a && b))) {
                info('auto login not set; please login classic.')
                setIsAuto(false)
                return
            }
            try {
                let accessToken = token;
                if(!accessToken && a && b) {
                    info('auto loginWithAB', { email, a, b })
                    try {
                        accessToken = await apiService.loginWithAB(email, a, b);
                    } catch (e: any) {
                        if(isAxiosError(e) && e.response?.status === 401) {
                            alert('The link is invalid or expired. Please use the classic login or request a new link. (401)')
                        }
                        logException('loginWithAB failed; please login classic.', e?.message)
                        setIsAuto(false)
                        return
                    }
                }
                apiService.installToken(email, accessToken)
                await postLogin(queryParams as Required<QueryParams>, commons)
                // setIsAuto(false) FIXME
            } catch (e: any) {
                logException('loginWithAB or postLogin failed; please login classic.', e?.message)
                apiService.logout()
                setIsAuto(false)
            }
        })()
    }, [email, token, a, b, loading])
    return {
        isAuto,
        queryParams,
    }
}
